import React from 'react';
import { Layers, Wrench, Package } from 'lucide-react';

export const MARGIN_VIEWS = [
  { id: 'combined', label: 'Combined', prefix: 'total_', icon: Layers, below: 'below_guardrail_count_total', desc: 'Implementation services + product subscription (full term), in AUD.' },
  { id: 'implementation', label: 'Implementation', prefix: '', icon: Wrench, below: 'below_guardrail_count', desc: 'Implementation services only — sell vs internal cost rates, in AUD.' },
  { id: 'product', label: 'Product', prefix: 'product_', icon: Package, below: 'below_guardrail_count_product', desc: 'Product subscriptions only — net of discounts over the full term vs price-book cost basis, in AUD.' },
];
export const viewKey = (view, field) => `${view.prefix}${field}`;
export const marginTone = (pct, min) => (pct == null ? 'text-slate-300' : pct < 0 ? 'text-rose-600' : (min != null ? pct < min : pct < 20) ? 'text-amber-600' : 'text-emerald-700');

/** Combined | Implementation | Product pill switcher for the Margin tab. */
export function MarginViewSwitcher({ view, onChange, counts }) {
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="margin-view-switcher">
      <div className="inline-flex rounded-full border border-slate-200 bg-white p-0.5">
        {MARGIN_VIEWS.map((v) => {
          const Icon = v.icon;
          const active = view === v.id;
          return (
            <button key={v.id} type="button" onClick={() => onChange(v.id)} data-testid={`margin-view-${v.id}`}
              className={`inline-flex items-center gap-1.5 text-xs px-3 py-1 rounded-full transition-colors ${active ? 'bg-[#0F2040] text-white' : 'text-slate-600 hover:bg-slate-50'}`}>
              <Icon className="w-3 h-3" /> {v.label}
              {counts?.[v.id] != null && <span className={`text-[10px] ${active ? 'text-white/70' : 'text-slate-400'}`}>{counts[v.id]}</span>}
            </button>
          );
        })}
      </div>
      <span className="text-[11px] text-slate-400" data-testid="margin-view-desc">{MARGIN_VIEWS.find((v) => v.id === view)?.desc}</span>
    </div>
  );
}
